import {Action, action} from 'easy-peasy';

export interface QualityAssuranceDataReportState {
  activeUser: number;
  activeReportType?: string;
  activeEventType?: string;
  activeDate?: string;
  activeDateType?: string;
  items: any[];
  searchPagesList: any[];
  searchCurrentPage: number;
  loading: boolean;
  setActiveReportType: Action<QualityAssuranceDataReportState, string>;
  setActiveEventType: Action<QualityAssuranceDataReportState, string>;
  setActiveDate: Action<QualityAssuranceDataReportState, string>;
  setActiveDateType: Action<QualityAssuranceDataReportState, string>;
  loadQualityAssuranceDataReport: Action<QualityAssuranceDataReportState, any[]>;
  setSearchPagesList: Action<QualityAssuranceDataReportState, any[]>;
  setSearchCurrentPage: Action<QualityAssuranceDataReportState, number>;
  setLoading: Action<QualityAssuranceDataReportState, boolean>;
}

const qualityAssuranceDataReport: QualityAssuranceDataReportState = {
    activeUser: 0,
    setActiveReportType: action((state, activeReportType) => {
        state.activeReportType = activeReportType;
    }),
    setActiveEventType: action((state, activeEventType) => {
        state.activeEventType = activeEventType;
    }),
    setActiveDate: action((state, activeDate) => {
        state.activeDate = activeDate;
    }),
    setActiveDateType: action((state, activeDateType) => {
        state.activeDateType = activeDateType;
    }),
    items: [],
    loadQualityAssuranceDataReport: action((state, qualityAssuranceDataReport) => {
        state.items = qualityAssuranceDataReport;
    }),
    searchPagesList: [],
    setSearchPagesList: action((state, searchPagesList) => {
        state.searchPagesList = searchPagesList;
    }),
    searchCurrentPage: 1,
    setSearchCurrentPage: action((state, searchCurrentPage) => {
        state.searchCurrentPage = searchCurrentPage;
    }),
    loading: false,
    setLoading: action((state, loading) => {
        state.loading = loading;
    }),
};

export default qualityAssuranceDataReport;
